import Forum from "messaging/forums/forum";
import Message from "messaging/message";

type BulkMessageRequest = {
  id?: string;  
  forum?: Forum;
  subject: string;
  contentPlainText: string;
  markCreated: boolean;
  markDeleted: boolean;
  markRead: boolean;
  markUnread: boolean;
  isAutoGenerated: boolean;
  publish?: boolean;
}

export default class BulkMessageAPIRequest {
  public payload: Array<BulkMessageRequest>;

  public constructor(messages: Message[]) {
    this.payload = [];
    
    for (const message of messages) {
      this.payload.push({
        id: message.id?.value,
        forum: new Forum(message.forum),
        subject: message.subject ?? "",
        contentPlainText: message.content,
        markCreated: message.isMarkedForCreation ?? false,
        markDeleted: message.isMarkedForDeletion ?? false,
        markRead: message.isMarkedRead ?? false,
        markUnread: message.isMarkedUnread ?? false,
        isAutoGenerated: message.isAutoGenerated ?? false,
        publish: message.isMarkedForPublish ?? false
      });
    }
  }
}
